import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import Home from '../views/Home.vue';
import Login from '@/views/Login.vue';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    props: true,
    meta: {
      requireLogin: false,
    },
  },
  {
    path: '/',
    name: 'Home',
    component: Home,
  },

];

const router = new VueRouter({
  mode: 'history',
  base: process.env.PUBLIC_PATH,
  routes,
});

export default router;
